import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { State } from "../state";
import PaymentTrustBadges from "./payment/PaymentTrustBadges";
import styles from "./Footer.module.css";

/** TR routes live at the root; EN routes live under /en with English slugs. */
const slugs = (isEnglish: boolean) => {
  const p = isEnglish ? "/en" : "";
  return {
    about: `${p}/about/`,
    contact: `${p}/contact/`,
    pricing: isEnglish ? "/en/pricing/" : "/fiyatlandirma/",
    answers: isEnglish ? "/en/faq/" : "/sss/",
    kvkk: `${p}/kvkk/`,
    privacy: isEnglish ? "/en/privacy/" : "/gizlilik/",
    distanceSales: isEnglish ? "/en/distance-sales/" : "/mesafeli-satis-sozlesmesi/",
    deliveryReturn: isEnglish ? "/en/delivery-return/" : "/teslimat-iade/",
  };
};

/**
 * Site-wide footer: company/legal navigation + the Visa/Mastercard/iyzico trust badges. Required for
 * İyzico merchant activation (their website-criteria checklist wants the payment logos and the legal
 * pages discoverable). Rendered on every page under the router.
 */
const Footer: React.FC = () => {
  const languageData = useSelector((state: State) => state.languageReducer);
  const isEnglish = languageData?.appLanguage === "en";
  const t = languageData?.data?.footer;
  const url = slugs(isEnglish);

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brandCol}>
          <span className={styles.brand}>Shift Tracker</span>
          <p className={styles.tagline}>{t?.tagline}</p>
          <PaymentTrustBadges variant="footer" className={styles.badges} />
        </div>

        <nav className={styles.linkCol} aria-label={t?.companyHeading}>
          <span className={styles.colHeading}>{t?.companyHeading}</span>
          <Link to={url.about}>{t?.about}</Link>
          <Link to={url.pricing}>{t?.pricing}</Link>
          <Link to={url.answers}>{t?.answers}</Link>
          <Link to={url.contact}>{t?.contact}</Link>
        </nav>

        <nav className={styles.linkCol} aria-label={t?.legalHeading}>
          <span className={styles.colHeading}>{t?.legalHeading}</span>
          <Link to={url.distanceSales}>{t?.distanceSales}</Link>
          <Link to={url.deliveryReturn}>{t?.deliveryReturn}</Link>
          <Link to={url.privacy}>{t?.privacy}</Link>
          <Link to={url.kvkk}>{t?.kvkk}</Link>
        </nav>
      </div>

      <div className={styles.bottom}>
        &copy; {new Date().getFullYear()} Shift Tracker. {t?.rights}
      </div>
    </footer>
  );
};

export default Footer;
